import { createModel } from "hox";
import { message } from "antd";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import React, { useState, useEffect } from "react";
import { PaginationProps } from "antd/es/pagination";

import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { IDetailList, ISaleSoFields, ISaleSoDetail, ISaleSoSearch, Ids, Detailed, ISaleSoStatistics } from "./saleOrderTypes"
import { saleOrderService } from "./saleOrderService"
import { convertRes2Blob } from "@/utils/exportFile";
import { formatNum } from "@/utils/utils";
export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.pageNum
    }
}

export const useSaleOrderModel = createModel(function () {
    const initSearchParam: ISaleSoSearch = {};
    const initDataSource: ISaleSoDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initDesc: ISaleSoStatistics = {
        amountReceived: 0,
        discountTotalAmount: 0,
        receivedAmount: 0,
        totalAmount: 0,
        totalNum: 0        
    }
    //查询条件
    const [searchParam, setSearchParam] = useState<ISaleSoSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<ISaleSoDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<ISaleSoFields>({});
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [descTotal, setDescTotal] = useState<ISaleSoStatistics>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<ISaleSoStatistics>(initDesc);
    const [descRows, setDescRows] = useState<ISaleSoFields[]>([]);
    //列表数据源分页参数

    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as ISaleSoFields)
    }, [selectedRowKeys, dataSource])
    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item) => {
            let { totalNum, totalAmount, discountTotalAmount, receivedAmount,amountReceived } = item
            newRowsDescTotal.amountReceived += +formatNum(amountReceived)
            newRowsDescTotal.discountTotalAmount += +formatNum(discountTotalAmount)
            newRowsDescTotal.receivedAmount += +formatNum(receivedAmount)
            newRowsDescTotal.totalAmount += +formatNum(totalAmount)
            newRowsDescTotal.totalNum += +formatNum(totalNum)

        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])
    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: ISaleSoSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const loadData = async (page?: ISearchPage, searchValue: ISaleSoSearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await saleOrderService.page(searchParams);
        const { records, statistics, ...pg } = retData;
        setPgCfg(transPgToPagination({ ...pg, pageNum: pg.current }));
        setDataSource(records);
        setDescTotal(statistics);
    }
    const invalidateData = async (obj: object) => {
        let { retData } = await saleOrderService.invalidate(obj)
        if (retData) {
            message.success("作废成功");
            loadData();
        }
    }
    const onPrinting = async (obj: object) => {
        let { retData } = await saleOrderService.printNum(obj)
        if (retData) {
            loadData();
        }
    }
    const [print, setPrint] = useState<boolean>(false);
    //结算弹框
    const [settleVisible, setSettleVisible] = useState<boolean>(false);
    const Settle = async (data: any) => {
        // let { retData } = await saleOrderService.settl(data);
        // return retData
    }

    const [offerPrint, setOfferPrint] = useState<boolean>(false);
    const [salePrint, setSalePrint] = useState<boolean>(false);
    //列表导出
    const listExport = async () => {
        let result = await saleOrderService.export({ ...searchParam, id: selectedRowKeys.join()});
        convertRes2Blob(result)
    }
    const detailsExport = async () => {
        let result = await saleOrderService.detailsExport({
            ...searchParam,
            "pageSize": "0",
            "pageNum": "0",
            id: selectedRowKeys.join(),
        });
        convertRes2Blob(result)
    }

    // 转销售单
    const onTransfer = async (planCode:string) =>{
        let { retData } = await saleOrderService.transfer(planCode);
        return retData
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedRow,
        drawerVisible,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setSelectedRow,
        setDrawerVisible,
        invalidateData,
        print, setPrint, onPrinting,
        settleVisible, setSettleVisible,
        offerPrint, setOfferPrint,
        salePrint, setSalePrint,
        Settle,
        listExport,
        detailsExport,
        descTotal, setDescTotal,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows,
        onTransfer
    }
});